import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// common
import enCommon from './locales/en/common.json';
import nlCommon from './locales/nl/common.json';

// home
import enHome from './locales/en/home.json';
import nlHome from './locales/nl/home.json';

// solutions
import enKickstarter from './locales/en/solutions/kickstarter.json';
import nlKickstarter from './locales/nl/solutions/kickstarter.json';

import enImplementation from './locales/en/solutions/implementation.json';
import nlImplementation from './locales/nl/solutions/implementation.json';

import enConsultancy from './locales/en/solutions/consultancy.json';
import nlConsultancy from './locales/nl/solutions/consultancy.json';

// expertise
import enIndustry40 from './locales/en/expertise/industry4-0.json';
import nlIndustry40 from './locales/nl/expertise/industry4-0.json';

import enIIoT from './locales/en/expertise/iiot.json';
import nlIIoT from './locales/nl/expertise/iiot.json';

import enCyberSecurity from './locales/en/expertise/cyber-security.json';
import nlCyberSecurity from './locales/nl/expertise/cyber-security.json';

// contact
import enContact from './locales/en/contact.json';
import nlContact from './locales/nl/contact.json';

// about
import enAbout from './locales/en/about.json';
import nlAbout from './locales/nl/about.json';

// articles
import enArticles from './locales/en/articles.json';
import nlArticles from './locales/nl/articles.json';

// jobs
import enJobs from './locales/en/jobs.json';
import nlJobs from './locales/nl/jobs.json';

// use-cases
import enDigitalFactory from './locales/en/use-cases/digital-factory.json';
import nlDigitalFactory from './locales/nl/use-cases/digital-factory.json';
import enDigitalWarehousing from './locales/en/use-cases/digital-warehousing.json';
import nlDigitalWarehousing from './locales/nl/use-cases/digital-warehousing.json';
import enPaperlessOperations from './locales/en/use-cases/paperless-operations.json';
import nlPaperlessOperations from './locales/nl/use-cases/paperless-operations.json';
import enRealTimeProduction from './locales/en/use-cases/real-time-production.json';
import nlRealTimeProduction from './locales/nl/use-cases/real-time-production.json';

// error
import enError from './locales/en/error.json';
import nlError from './locales/nl/error.json';

const domainDetector = {
  name: 'domain',
  lookup() {
    if (typeof window === 'undefined') return null;
    const host = window.location.hostname.toLowerCase();
    if (host.endsWith('.nl')) return 'nl';
    if (host.endsWith('.com')) return 'en';
    return null;
  }
};

const detector = new LanguageDetector();
detector.addDetector(domainDetector);

export default i18n
    .use(detector)
    .use(initReactI18next)
    .init({
        detection: {
            order: ['domain', 'localStorage', 'navigator'],
            lookupLocalStorage: 'appLang',
            caches: ['localStorage']
        },
        resources: {
            en: { 
                common: enCommon, 
                home: enHome, 
                kickstarter: enKickstarter, 
                implementation: enImplementation, 
                consultancy: enConsultancy, 
                'industry4-0': enIndustry40, 
                iiot: enIIoT, 
                'cyber-security': enCyberSecurity,
                contact: enContact,
                about: enAbout,
                articles: enArticles,
                jobs: enJobs,
                'digital-factory': enDigitalFactory,
                'digital-warehousing': enDigitalWarehousing,
                'paperless-operations': enPaperlessOperations,
                'real-time-production': enRealTimeProduction,
                error: enError
            },
            nl: { 
                common: nlCommon, 
                home: nlHome, 
                kickstarter: nlKickstarter, 
                implementation: nlImplementation, 
                consultancy: nlConsultancy, 
                'industry4-0': nlIndustry40, 
                iiot: nlIIoT, 
                'cyber-security': nlCyberSecurity, 
                contact: nlContact,
                about: nlAbout,
                articles: nlArticles,
                jobs: nlJobs,
                'digital-factory': nlDigitalFactory,
                'digital-warehousing': nlDigitalWarehousing,
                'paperless-operations': nlPaperlessOperations,
                'real-time-production': nlRealTimeProduction,
                error: nlError
            }
        },
        fallbackLng: 'en',
    ns: ['common', 'home', 'kickstarter', 'implementation', 'consultancy', 'industry4-0', 'iiot', 'cyber-security', 'contact', 'about', 'articles', 'jobs', 'digital-factory', 'digital-warehousing', 'paperless-operations', 'real-time-production', 'error'],
        defaultNS: 'home',
        interpolation: { escapeValue: false },
        react: { useSuspense: false }
    });

i18n.on('languageChanged', (lng) => {
    try { document.documentElement.lang = lng; } catch (e) {}
});